export default {
    root: ({ instance, context }) => {
      const state = instance.$attrs?.state || 'default';
      const size = instance.$attrs?.size || 'md';
      const invalid = instance.$attrs?.invalid || false;
      const disabled = instance.$attrs?.disabled || false;

      return {
        class: [
            'p-inputgroup-root',
            `p-inputgroup_${state}`,
            `p-inputgroup_${size}`,
            invalid ? 'p-inputgroup_invalid' : '',
            disabled ? 'p-inputgroup_disabled' : ''
        ]
      };
    },

  input: ({ instance }) => ({
    class: [
      'p-inputfiled-root',
      {
        'p-inputgroup-field_with-leading': !!instance?.iconLeading,
        'p-inputgroup-field_with-trailing': !!instance?.iconTrailing,
        'p-inputgroup-field_disabled': !!instance?.$attrs?.disabled
      }
    ]
  }),

  label: ({ instance }) => ({
    class: [
      'p-inputgroup-label',
      instance?.$attrs?.disabled ? 'p-inputgroup-label_disabled' : ''
    ]
  }),

  hint: ({ instance }) => ({
    class: [
      'p-inputgroup-hint',
      instance?.$attrs?.disabled ? 'p-inputgroup-hint_disabled' : ''
    ]
  })
};
